/**
 * Compute month-view info from a date.
 * Uses the runtime's local timezone (matches HomeScreen/CalendarScreen behaviour).
 */
export function getMonthViewInfo(viewDate: Date): {
  year: number
  month: number
  monthLabel: string
  firstDayOfMonth: number
  daysInMonth: number
} {
  const year = viewDate.getFullYear()
  const month = viewDate.getMonth()
  const monthLabel = viewDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
  const firstDayOfMonth = new Date(year, month, 1).getDay()
  const daysInMonth = new Date(year, month + 1, 0).getDate()
  return { year, month, monthLabel, firstDayOfMonth, daysInMonth }
}

/**
 * Check if an event falls on a specific calendar day.
 * Takes the raw event_date string to stay free of ApiEvent type dependencies.
 * Uses local timezone date parts (matches getMonthViewInfo behaviour).
 */
export function isEventOnDay(eventDateStr: string, day: number, month: number, year: number): boolean {
  const d = new Date(eventDateStr)
  return d.getDate() === day && d.getMonth() === month && d.getFullYear() === year
}

/**
 * Generate the day array for a calendar grid month view.
 * Returns negative/zero values for leading padding days followed by 1..daysInMonth.
 */
export function getCalendarDays(firstDayOfMonth: number, daysInMonth: number): number[] {
  return Array.from({ length: firstDayOfMonth + daysInMonth }, (_, i) => i - firstDayOfMonth + 1)
}
